PJQ.views.paysimple = {};

PJQ.views.paysimple.SignUpOpenedModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-paysimple-sign-up-opened'),
		maxWidth: 500,
		isShowCloseButton: true,
		isVerticalCenter: true
	}
});